<template>
  <div class="content">
    <div>
      <div>
        <!--内容展示区域-->
        <div class="contentListTop bg-white">
          <span id="bankName" style='font-size:16px; color:#495060;text-align:left;display:inline-block;width:100%'>
            {{base.productName}}
          </span>
          <ul class="contentListTopContentList">
            <li>
              <p class="page_color_1C2438">{{productCategory=='1'?'客户姓名':'企业名称'}}</p>
              <p class="page_color_1C2438">{{productCategory=='1'?base.borrowerName:base.corpName}}</p>
            </li>
            <li>
              <p class="page_color_1C2438">提款日期</p>
              <p class="page_color_1C2438"> {{base.drawTime}} </p>
            </li>
            <li>
              <p class="page_color_1C2438">提款金额</p>
              <p class="page_color_1C2438"> {{base.drawAmt}}元</p>
            </li>
            <li>
              <p>
                <span class="page_color_1C2438 tl">本期应还</span>
                <span class="page_color_1C2438 fr">{{base.repayAmt}}元</span>
              </p>
              <p class='fr light-gray'> {{base.dueDate}}</p>
            </li>
            <li class="bdn" id="bdn">
              <p class="page_color_1C2438">
                <span>待还金额</span>
                <span class="page_color_B7BFD2 mgt_7 light-gray fz12 ml7">
                  以最终还款金额为准
                </span>
                <span class='fr' v-if="productId == 'HANHUA-FPD'">--</span>
                <span class='fr' v-if="productId != 'HANHUA-FPD'"> {{base.waitRepayAmt}}元</span>
              </p>
              <!-- <p class='fr' v-show="repay">
            <a class="orange lh30" @click="prepayment">
            <i class='orange iconfont icon-you fr'></i>
            提前还款
            </a>
            </p> -->

            </li>

            <div v-show="productId === 'SN-FPD'">
              <li>
                <p class="page_color_1C2438">还款账户名称</p>
                <p class="page_color_1C2438">{{base.putoutCardBank || '--' }}</p>
              </li>
              <li>
                <p class="page_color_1C2438">还款账号</p>
                <p class="page_color_1C2438">{{base.putoutCardNo || '--' }}</p>
              </li>
              <li>
                <p class="page_color_1C2438">开户行名称</p>
                <p class="page_color_1C2438">{{base.bankName || '--' }}</p>
              </li>
            </div>
          </ul>
        </div>
        <div class="footerTwoButtonBox" v-show="repay">
          <FooterTwoButton :leftNext="goToNextPage" :rightNext="prepayment" left="还款指引" right="主动还款" :repay='repay'></FooterTwoButton>
        </div>
        <div class="footerTwoButtonBox" v-show="!repay">
          <FooterTwoButton :leftNext="goToNextPage" :rightNext="prepayment" :repay='repay' left="还款指引" right=""></FooterTwoButton>
        </div>
        <div class="contentListBottom boder_F8F8F9_top_8">
          <div class="contentListBottomTitle page_color_1C2438 page_fwb page_ftsz_17">
            还款详情
            <!-- <span class=" termNoborder">
              贷款期数{{base.term}}个月
            </span> -->
          </div>
          <div class="contentListBottomContent">
            <table class="tl_center">
              <tr>
                <td class="page_color_1C2438 tl_left">期数</td>
                <td class="page_color_1C2438">还款日</td>
                <td class="page_color_1C2438">还款金额</td>
                <td class="page_color_1C2438">状态</td>
                <td class="page_color_1C2438">应还本金</td>
                <td class="page_color_1C2438">应还利息</td>
              </tr>
              <fragment v-for="item in base.loanSupermarketRepayList" v-bind:key="item.id">
                <!-- <a v-if="item.current === '1'" class="page_color_FC8965" href="javascript:;">本期</a> -->

                <tr v-if="item.repayStatus == '0'">
                  <td class="gray tl_left">
                    <span>{{item.repayNum}}/{{base.term}} 期</span>
                    <a v-if="item.current === '1'" class="page_color_FC8965" href="javascript:;">本期</a>
                  </td>
                  <td class="gray">{{item.dueDate}}</td>
                  <td class="gray">¥{{item.repayAmt}}</td>
                  <td class="gray">未还款</td>
                  <td class="gray">{{ item.refundPrincipal || '--' }}</td>
                  <td class="gray">{{ item.refundInterest || '--' }}</td>
                </tr>

                <!-- // 已还 -->
                <tr v-if="item.repayStatus == '1'">
                  <td class="page_color_B7BFD2  tl_left">
                    <span v-if="item.repayNum == '999'">--</span>
                    <span v-if="item.repayNum != '999'">{{item.repayNum}}/{{base.term}}期</span>
                    <a v-if="item.current === '1'" class="page_color_FC8965" href="javascript:;">本期</a>
                  </td>
                  <td class="page_color_B7BFD2">{{item.dueDate}}</td>
                  <td class="page_color_B7BFD2">¥{{item.repayAmt}}</td>
                  <td class="page_color_B7BFD2 red">已还款</td>
                  <td class="gray">{{ item.refundPrincipal || '--' }}</td>
                  <td class="gray">{{ item.refundInterest || '--' }}</td>
                </tr>
                <!-- // 2逾期 -->
                <tr v-if="item.repayStatus == '2'">
                  <td class="black page_fwb tl_left">
                    <span>{{item.repayNum}}/{{base.term}}期</span>
                    <a v-if="item.current === '1'" class="page_color_FC8965" href="javascript:;">本期</a>
                  </td>
                  <td class="black page_fwb">{{item.dueDate}}</td>
                  <td class="black page_fwb">¥{{item.repayAmt}}</td>
                  <td class="page_fwb red">逾期</td>
                  <td class="gray">{{ item.refundPrincipal || '--' }}</td>
                  <td class="gray">{{ item.refundInterest || '--' }}</td>
                </tr>

                <!-- // 3-- -->
                <tr v-if="item.repayStatus > 2">
                  <td class="gray tl_left">
                    <span>{{item.repayNum}}/{{base.term}}期</span>
                    <a v-if="item.current === '1'" class="page_color_FC8965" href="javascript:;">本期</a>
                  </td>
                  <td class="black">{{item.dueDate}}</td>
                  <td class="black">¥{{item.repayAmt}}</td>
                  <td class="page_fwb">--</td>
                  <td class="gray">{{ item.refundPrincipal || '--' }}</td>
                  <td class="gray">{{ item.refundInterest || '--' }}</td>
                </tr>
              </fragment>
            </table>
          </div>
        </div>
      </div>
      <Button class="btn-bottom" type="info" text="贷后用途上传" :click="goPostLoan" v-if="productId=='YL-YPD'" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Dialog, Toast } from 'vant';
import Button from '@/components/Button.vue';
import FooterTwoButton from './FooterTwoButton.vue';

export default {
  name: 'repaymentPlan',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    FooterTwoButton,
    Button,
  },
  data() {
    const {
      drawId,
      corpId,
      productId,
      orderId,
    } = this.$route.query;

    return {
      productCategory: '',
      drawId,
      corpId,
      productId: Array.isArray(productId) ? productId[productId.length - 1] : productId,
      orderId: Array.isArray(orderId) ? orderId[orderId.length - 1] : orderId,
      base: {},
      repay: false, // 提前还款按钮是否展示
      repaymentUrl: '', // 提前还款按钮跳转链接
      repayGuide: '', // 还款指引的链接
      repayJumpData: {}, // 提前还款返回信息
    };
  },
  mounted() {
    this.initData();

    this.buttonController();
    this.repayJump();
    this.getRepayGuide();
    console.log(this.$route);
    this.getProductCategory()
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },

  methods: {
    getProductCategory(){
      this.$api.PublicPage.getProductDetail([this.productId]).then((res) => {
        if (res.success) {
          this.productCategory = res.data[0].productCategory
        }
      });
    },

    // 跳转贷后用途上传页面（仅亿联）
    goPostLoan() {
      const {
        drawId,
        orderId,
      } = this;
      this.$router.push({
        path: '/supermarket/v2/postLoanPurposeUpload',
        query: {
          drawId,
          orderId,
        },
      });
    },
    // 获取前端指引的链接
    getRepayGuide() {
      const {
        orderId,
      } = this;
      this.$api.PublicPage.getRepayGuide({
        orderId,
      }).then((res) => {
        if (res.success) {
          this.repayGuide = res.data ? res.data.url : '';
        }
      });
    },
    initData() {
      const {
        drawId,
        corpId,
        orderId,
      } = this;

      this.$api.PublicPage.getRepaymentPlan({
        drawId,
        corpId,
      })
        .then((res) => {
          if (res.success) {
            const { data } = res;
            this.base = { ...data };
            console.log(this.base);
            console.log(this);
            localStorage.setItem('orderId', orderId);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 提前还款按钮是否展示
    async buttonController() {
      const { productId, drawId, orderId } = this;
      try {
        const { data } = await this.$api.PublicPage.buttonController({ productId, drawId, orderId });
        data.forEach((e) => {
          this[e.key] = e.button;
        });
        // 跟后台确认，提前还款按钮显隐判断通过后台字段，替换原逻辑(productId === 'SPDB-FPD' && base.waitRepayAmt !== 0) || (productId == 'DM-FPD' && base.waitRepayAmt !== 0)
      } catch (e) {
        Toast('提前还款接口异常');
      }
    },
    // 跳转到还款试算页面
    async repayJump() {
      const { productId, orderId, drawId } = this;

      this.$toast.loading({
        message: '加载中...',
        clear: true,
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
      });


      try {
        const res = await this.$api.PublicPage.repayJump({ productId, orderId, drawId });
        this.repaymentUrl = res.data;
        this.repayJumpData = res;
        this.$toast.clear();
      } catch (e) {
        Toast('提前还款跳转失败');
        this.$toast.clear();
      }
    },
    prepayment() {
      const { drawId, base } = this;
      localStorage.setItem('drawId', drawId);
      localStorage.setItem('waitprincipal', base.waitprincipal);
      // 原逻辑屏蔽，重定向到后台返回url
      // TODO-YXF 模拟后台返回地址
      // this.repaymentUrl = "/supermarket/v2/calculationRepaymentStandard?productId=SN-FPD&pageId=4";

      // 判断一下 url 是否返回
      if (this.repayJumpData.success) {
        window.location.href = this.repayJumpData.data;
      } else {
        Toast(this.repayJumpData.returnMessage);
      }
      // 读秒跳转
      // if (productId === 'DM-FPD') {
      //   this.getPintecUrl();
      // } else if (productId === 'SPDB-FPD') {
      //   localStorage.setItem('drawId', drawId);
      //   localStorage.setItem('waitprincipal', base.waitprincipal);
      //   window.location.href = '/supermarket/v2/calculationRepayment';
      // }
    },
    goToNextPage() {
      console.log('this.repayGuide====', this.repayGuide);
      if (this.repayGuide) {
        window.location.href = this.repayGuide;
      } else {
        Toast('暂无还款指引内容');
      }
    },
  },
};
</script>
<style scoped>
/*颜色*/
.light-gray {
  color: #b7bfd2;
  font-size: 14px;
}
.shallow-gray {
  color: #9ea7b4;
}

/*字体大小*/

/*高度*/
.h48 {
  height: 48px;
}

.h40 {
  height: 40px;
}

.h140 {
  height: 140px;
}

.h220 {
  height: 220px;
}

.h150 {
  height: 150px;
}

.h180 {
  height: 180px;
}

.lh40 {
  line-height: 40px;
}

/*行高*/
.lh30 {
  line-height: 30px;
}

/*清除浮动*/
.clear {
  clear: both;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

/*外边距*/
.ml7 {
  margin-left: 0.07rem;
}

.ml20 {
  margin-left: 0.2rem;
}

.mt10 {
  margin-top: 0.1rem;
}

.mt15 {
  margin-top: 0.15rem;
}

.mt20 {
  margin-top: 0.2rem;
}

.mb15 {
  margin-bottom: 0.15rem;
}

/*内边距*/
.pt12-zero {
  padding-top: 0.12rem;
}

.pb22 {
  padding-bottom: 22px;
}

/*颜色*/
.orange {
  color: #f65846;
}

.red {
  color: #d0021b;
}

.gray {
  color: #495060;
  font-size: 14px;
}

.black {
  color: #1c2438;
}

/*背景颜色取值日*/
.bg-white {
  background: #ffffff;
}

.bg-gray {
  background: #9b9b9b;
}

.bg-red {
  background: linear-gradient(to bottom, #f5514a, #f5683c);
}

/*文字对齐方式*/
.center {
  text-align: center;
}

.tl {
  text-align: left;
}

.tr {
  text-align: right;
}

/*边框*/
.bold-none {
  border: none;
}

.box-bottom {
  border-bottom: 1px solid #e9eaec;
}

.line10 {
  width: 100%;
  height: 10px;
  background: #f8f8f9;
}

.line1 {
  width: 100%;
  height: 1px;
  background: #e9eaec;
}

/*按钮*/
.nav-btn {
  width: 3.45rem;
  height: 0.44rem;
  border: 1px solid #f65249;
  font-size: 0.17rem;
  border-radius: 0.04rem;
}

.nav-btn a {
  color: #f65249;
}

.btn-max {
  width: 3.45rem;
  height: 0.44rem;
  display: block;
  text-align: center;
  margin: 0 auto;
  border-radius: 0.04rem;
}

.btn-max a {
  color: #ffffff;
}

.padding-lr-15 {
  padding: 0 0.15rem 0 0.15rem;
}

.block {
  display: block;
}

.none {
  display: none;
}

/*鼠标状态样式*/
.not-allowed {
  cursor: not-allowed;
}

/*宽度*/
.w24 {
  width: 0.24rem;
}
.w18 {
  width: 0.18rem;
}
.w160 {
  width: 1.6rem;
}
.w60 {
  width: 0.6rem;
}
.res {
  position: relative;
  left: 0;
  top: 0;
}

.content {
  /*-webkit-overflow-scrolling: touch;*/
  overflow: auto;
  flex: 1;
  background: white;
  padding: 10px;
}

/*字体颜色*/
.page_color_B7BFD2 {
  color: #b7bfd2;
  font-size: 14px;
}

.page_color_1C2438 {
  color: #1c2438;
  font-size: 14px;
}

.page_color_495060 {
  color: #495060;
  font-size: 14px;
}

.page_color_D0021B {
  color: #d0021b;
  font-size: 14px;
}

.page_color_FC8965 {
  color: #fc8965;
  background: #fdf4d0;
  margin-left: 0.07rem;
  font-size: 14px;
}

/*字体大小*/
.page_ftsz_17 {
  font-size: 14px;
}

/*字体加粗*/
.page_fwb {
  font-weight: bold;
}

/*table padding border*/
.tr_padding_border {
  padding: 0.12rem 0;
  border-bottom: 1px solid #dddee1 !important;
  font-size: 14px;
}

/*文字居中*/
.tl_center {
  text-align: center;
}

.tl_left {
  text-align: left;
}

/*按钮*/
.btn {
  width: 0.52rem;
  height: 0.27rem;
  color: #ffffff;
  background: #f56c50;
  text-align: center;
  line-height: 0.27rem;
  display: inline-block;
  margin-left: 0.08rem;
}

/*元素之间的距离*/
.mgt_7 {
  margin-top: 0.075rem;
}

.mgt_8 {
  margin-top: 0.08rem;
}

/*去除边框*/
#bdn {
  /* border-bottom: none; */
  /*padding-bottom: 0;*/
}

.border_DDDEE1_bottom {
  border-bottom: 1px solid #dddee1;
}

.boder_F8F8F9_top_8 {
  border-top: 8px solid #ffffff;
}

.contentListTopHeader {
  padding: 0.1rem 0.15rem 0.08rem 0.15rem;
  background: #f8f8f9;
}

.contentListTopContent {
  background: #ffffff;
  padding: 0 0rem;
}

.contentListTopContentTitle {
  padding: 0.13rem 0;
}

.contentListTopContentList {
  padding: 0 0.055rem;
}

.contentListTopContentList li {
  display: flex;
  justify-content: space-between;
  padding: 0;
  border-bottom: 1px solid #dddee1;
}
.contentListTopContentList li:nth-child(4) {
  display: block;
  position: relative;
}
.contentListTopContentList li:nth-child(4) p:first-child {
  display: block;
  text-align: left;
}
.contentListTopContentList li:nth-child(4) p.fr {
  position: absolute;
  top: 0.1rem;
  right: 0;
}
.contentListTopContentList li:nth-child(5) {
  display: block;
  position: relative;
}

.contentListTopContentList li:nth-child(5) p:first-child {
  display: block;
  text-align: left;
}
.contentListTopContentList li:nth-child(5) p.fr {
  position: absolute;
  top: -2px;
  right: 0;
  font-size: 14px;
}

.contentListBottom {
  background: #ffffff;
}

.contentListBottomTitle {
  text-align: left;
  font-size: 1rem;
  height: 3rem;
  line-height: 3rem;
}

.contentListBottomContent {
  padding: 0 0.07rem;
  overflow: hide;
  overflow-x: auto;
}

.contentListBottomContent table {
  width: 120%;
}

.contentListBottomContent table,
.contentListBottomContent table tr,
.contentListBottomContent table tr td {
  border: none;
  padding: 0.4rem 0;
}

.term {
  color: #b7bfd2;
  font-size: 14px;
  margin-left: 0.08rem;
}
.termNoborder {
  color: #b7bfd2;
  font-size: 14px;
  margin-left: 0.08rem;
}
#bankName {
  font-weight: bold;
}
.footerTwoButtonBox >>> .footer_Button {
  width: 100%;
}
.footerTwoButtonBox >>> .footer_Button_right {
  width: 164px !important;
  height: 44px;
  background: #f5f5f5;
  border-radius: 8px;
  border: 1px solid #f5f5f5;

  border-radius: 8px;
  color: #2f3133;
  font-weight: 390 !important;
  display: flex;
  font-weight: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.footerTwoButtonBox >>> .footer_Button_left {
  width: 164px !important;
  height: 44px;
  background: #ff6538;
  border: 1px solid #ff6538;
  border-radius: 8px;
  color: #fff;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.btn-bottom >>> .van-button{
  background-color: #ff6538;
  border: 1px solid #ff6538;
  border-radius: 8px;
  font-weight: 600;
}
</style>
